<template>
  <div class="l-body">
  <Top/>
  <div class="wrap" :class="bgId">
    <div class="l-wrap zheng">
      <div class="faqtit"><span id="game">{{game}}</span><span>-</span><span id="faqtype">{{wtname}}</span></div>
      <div class="help-menu-box">
        <div class="st_trees">
          <ul class="tree_a">
            <li  v-for="wt in wtlist" @click="an(wt.tablename,wt.id,wt.other)"><a>{{wt.tablename}}</a></li>
            <li v-if="id==2&&typeid==3&&vip=='true'" @click="gameWt1"><a>纪念指环转移</a></li>
            <li v-if="id==1&&typeid==9&&vip=='true'" @click="gameWt2"><a>VIP徽章转移</a></li>
            <li v-if="id==1&&typeid==1" @click="gameWt3" class="up"><a>SUN1贵宾用户身份认证</a></li>
            <li v-if="id==2&&typeid==2" @click="gameWt3" class="up"><a>S6贵宾用户身份认证</a></li>
          </ul>
        </div>
      </div>
	  <div class="help-jl-box">
	  <h1 v-show="show">{{tablename}}</h1>
	  <div class="xiangxi">
	  <table class="biaogea" v-show="show1">
		  <h1>物品被盗找回服务协议</h1>
		  <tr>
		  	<td>
		  <strong>1、特别提示</strong>
		  <p style="color:red" v-if="game=='仙境传说起源'">&nbsp;&nbsp;&nbsp;&nbsp;1.1
		  为了保证用户游戏账号的安全，建议用户对账号绑定官方免费提供的微信令宝并开启3分钟封停功能，同时设置允许登陆地区，不要向他人泄露账号信息，不登陆木马钓鱼网站，提高账号安全意识。</p>
		  <p style="color:red" v-if="game!='奇迹MU'&&game!='仙境传说起源'">&nbsp;&nbsp;&nbsp;&nbsp;1.1
		  为了保证用户游戏账号的安全，请用户务必对账号绑定官方免费提供的微信令宝并开启3分钟封停功能，自2020年1月1日开始，用户未对账号绑定微信令宝并开启区服封停功能导致账号被盗等情形而给自身造成损害的，由用户自己承担由此产生的直接和间接损失。官方将不再提供查询及找回服务。</p>
		  <p v-if="game!='奇迹MU'">&nbsp;&nbsp;&nbsp;&nbsp;1.2
		  其他特殊情况，用户在使用塔人网络提供的自助服务物品被盗找回之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。 </p>
		  <p v-if="game!='奇迹MU'">&nbsp;&nbsp;&nbsp;&nbsp;1.3
		  如用户进入自助服务-物品被盗找回页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。</p>
		  <p style="color:red" v-if="game=='奇迹MU'">&nbsp;&nbsp;&nbsp;&nbsp;1.1
		  为了保证用户游戏账号的安全，请用户务必对账号绑定官方免费提供的微信令宝并开启3分钟封停功能，自2022年4月1日开始，用户未对账号绑定微信令宝并开启区服封停功能导致账号被盗等情形而给自身造成损害的，由用户自己承担由此产生的直接和间接损失。官方将不再提供查询及找回服务。</p>
		  <p v-if="game=='奇迹MU'">&nbsp;&nbsp;&nbsp;&nbsp;1.2
		  用户在使用塔人网络提供的自助服务物品被盗找回之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。</p>
		  <p v-if="game=='奇迹MU'">&nbsp;&nbsp;&nbsp;&nbsp;1.3
		  如用户进入自助服务-物品被盗找回页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。</p>
		  <strong>2、服务内容</strong>
		  <p>
		     &nbsp;&nbsp;&nbsp;&nbsp;2.1 用户可通过此页面自助申请物品被盗找回，塔人网络收到申请后会根据用户提供的资料完整情况进行相应操作。
		  </p>
		   <p>
		     &nbsp;&nbsp;&nbsp;&nbsp;2.2 提交被盗找回申请的账号必须与被盗账号一致。
		  </p>
		   <p>
		     &nbsp;&nbsp;&nbsp;&nbsp;2.3 物品被盗时间与提交单据问题时间间隔不能超过7天。
		  </p>
		   <p>
		     &nbsp;&nbsp;&nbsp;&nbsp;2.4 物品被盗时间与最后一次看到时间不能超过7天。
		  </p>
		   <p>
		     &nbsp;&nbsp;&nbsp;&nbsp;2.5 请提供被盗物品的准确描述（物品的官方名称、属性，游戏币或点数的具体数量）。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;2.6 同个账号在一个月内只有一次提交物品被盗查询的机会。为保证帐号安全，请玩家及时对账号绑定微信令宝，并使用3分钟临时封停功能。如同一帐号在本月受理过被盗查询的，此后仍未在每次登陆时使用3分钟临时封停功能导致距上次被盗查询提交时间未满30天又发生被盗的，官方将不予受理。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;2.7 若被盗物品一旦经过转卖，我们替您追回的可能性会很小，还请您理解。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;2.8 在接到玩家要求后尝试追回被盗物品（不保证全部追回），如物品通过正常途径流失（包括但不限于：升级失败，出售给系统，被摧毁，正常消耗使用等情形属正常流失），我们无法为您取回虚拟物品，同时不做任何补偿。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;2.9 被盗物品已被变卖，由第三方合规购买，官方以降低双方损失前提下调解为主导。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;2.10 被盗账号在问题受理期间被临时封停想要提前解封，需向官方客服提交注册的身份证正反扫描件，手持件及半身照核实归属后才给予解封。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;2.11 其他特殊情况，官方将根据账号具体情况进一步查询回复，若经核实30天内的2次被盗属于可受理范畴，我们会为您找回仍留存在被盗账号上的相关被盗物品，以及通过5173合规通道出售的游戏道具（被盗72小时内），除此以外不再提供任何找回服务。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;2.12 被盗查询申请提交后，申请人若想要撤销本次查询申请，需在问题提交后5天内联系官方客服提交撤销申请。
		  </p>
		  <strong>3、使用规则</strong>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;3.1 用户承诺以其真实身份申请物品被盗找回。并保证所提供的信息真实、完整、有效。依据法律规定和本协议约定对所提供的信息承担相应的法律责任。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;3.2 塔人网络有权审查用户所提供的身份信息是否真实、有效。如果用户提供的资料不准确，不真实，不合法有效，塔人网络保留结束用户使用塔人网络各项服务的权利。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;3.3 如因用户违反有关法律、法规或本协议项下的任何条款而给塔人网络或任何其他第三方造成损害的，用户应当承担由此造成的损害赔偿责任。
		  </p>
		  <strong>4、争议解决</strong>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;4.1 本协议的订立、履行、解释及争议的解决均应适用中国法律。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;4.2 本协议的订立、履行、解释及争议的解决均应以塔人网络所提供之任何形式之电子数据、书面数据等相关内容为准，用户在此确认该等数据的准确性、有效性、合法性。
		  </p>
		  <p>
		      &nbsp;&nbsp;&nbsp;&nbsp;4.3 如各方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均应提交上海仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁的受理费用及处理费用将由提起仲裁一方独立全部承担。
		  </p>
		  <div class="anniu">
		      <button class="yes"  @click="y1">
		          同意
		      </button>
		      <button class="no"  @click="no">
		          不同意
		      </button>
		  </div>
			</td>
		</tr>
	  </table>
	  <table class="biaogea" v-show="show2">
		  <h1>解绑塔人微令宝服务协议</h1>
		  <tr>
		  	<td>
				<strong>1、特别提示 </strong>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;1.1 用户在使用塔人网络提供的自助服务解绑塔人微令宝产品之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。
				</p>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;1.2 如用户进入自助服务-解绑塔人微令宝页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。
				</p>
				<strong> 2、服务内容</strong>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;用户可通过此页面自助申请解绑塔人微令宝产品，塔人网络收到申请后会根据用户提供的资料完整情况进行相应操作。
				</p>
				<strong>3、使用规则</strong>
				<p style="color:red">
				    &nbsp;&nbsp;&nbsp;&nbsp;3.1 用户承诺以其真实身份申请自助解绑塔人微令宝问题查询。并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。
				</p>
				<p  style="color:red">
				    &nbsp;&nbsp;&nbsp;&nbsp;3.2 塔人网络有权审查用户所提供的身份信息是否真实、有效。如果用户提供的资料不准确，不真实，不合法有效，塔人网络保留结束用户使用塔人网络各项服务的权利。
				</p>
				<p  style="color:red">
				    &nbsp;&nbsp;&nbsp;&nbsp;3.3 如因用户违反有关法律、法规或本协议项下的任何条款而给塔人网络或任何其他第三方造成损害的，用户应当承担由此造成的损害赔偿责任。
				</p>
				<p  style="color:red">
					&nbsp;&nbsp;&nbsp;&nbsp;3.4严禁使用伪造、变造的居民身份证，伪造、变造居民身份证的行为已经构成犯罪，官方一旦发现用户使用虚假身份证件，将收集图片、视频信息提交给公安机关，依法追究法律责任。
				 </p>
				<strong>4、免责声明</strong>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;用户明确同意其使用塔人网络自助安全产品解绑微令宝所存在的风险将完全由其自行承担；因其使用此服务而产生的一切后果（包括但不限于塔人一号通、游戏点数、游戏装备的丢失、被盗、争议）也由其自己承担，塔人网络对用户不承担任何责任，并无义务承担任何相关后续损失。
				</p>
				<strong>5、争议解决</strong>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;5.1 本协议的订立、履行、解释及争议的解决均应适用中国法律。
				</p>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;5.2 本协议的订立、履行、解释及争议的解决均应以塔人网络所提供之任何形式之电子数据、书面数据等相关内容为准，用户在此确认该等数据的准确性、有效性、合法性。
				</p>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;5.3 如各方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均应提交上海仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁的受理费用及处理费用将由提起仲裁一方独立全部承担。
				</p>
				<div class="anniu">
				    <button class="yes" @click="y2">
				        同意
				    </button>
				    <button class="no" @click="no">
				        不同意
				    </button>
				</div>
			</td>
		  </tr>
	  </table>
	  <table class="biaogea" v-show="show3">
		  <h1>账号身份信息修改服务协议</h1>
		  <tr>
		  	<td>
				<strong>1、特别提示</strong>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;1.1 用户在使用塔人网络提供的自助服务账号身份信息修改之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。
				</p>
				<p>
				    &nbsp;&nbsp;&nbsp;&nbsp;1.2 如用户进入自助服务-账号信息身份修改页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。
				</p>
				<strong>2、服务内容</strong>
				<p>
				  &nbsp;&nbsp;&nbsp;&nbsp;用户可通过此页面自助申请账号信息身份修改服务，塔人网络收到申请后会根据用户提供的资料完整情况进行相应操作。
				</p>
				<strong>3、使用规则</strong>
				 <p  style="color:red">
				  &nbsp;&nbsp;&nbsp;&nbsp;3.1 用户承诺以其真实身份申请自助账号身份信息修改服务。并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。
				<p  style="color:red">
				  &nbsp;&nbsp;&nbsp;&nbsp;3.2 塔人网络有权审查用户所提供的身份信息是否真实、有效。如果用户提供的资料不准确，不真实，不合法有效，塔人网络保留结束用户使用塔人网络各项服务的权利。
				</p>
				<p  style="color:red">
				  &nbsp;&nbsp;&nbsp;&nbsp;3.3 严禁使用伪造、变造的居民身份证，伪造、变造居民身份证的行为已经构成犯罪，官方一旦发现用户使用虚假身份证件，将收集图片、视频信息提交给公安机关，依法追究法律责任。
				</p>
				<p style="color:red">
				  &nbsp;&nbsp;&nbsp;&nbsp;3.4 如因用户违反有关法律、法规或本协议项下的任何条款而给塔人网络或任何其他第三方造成损害的，用户应当承担由此造成的损害赔偿责任。
				</p>
				<strong>4、争议解决</strong>
				<p>
				  &nbsp;&nbsp;&nbsp;&nbsp;4.1 本协议的订立、履行、解释及争议的解决均应适用中国法律。
				</p>
				<p>
				  &nbsp;&nbsp;&nbsp;&nbsp;4.2 本协议的订立、履行、解释及争议的解决均应以塔人网络所提供之任何形式之电子数据、书面数据等相关内容为准，用户在此确认该等数据的准确性、有效性、合法性。
				</p>
				<p>
				  &nbsp;&nbsp;&nbsp;&nbsp;4.3 如各方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可提交上海仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁的受理费用及处理费用将由提起仲裁一方独立全部承担。
				</p>
				<div class="anniu">
				    <button class="yes" @click="y3">
				        同意
				    </button>
				    <button class="no" @click="no">
				        不同意
				    </button>
				</div>
			</td>
		  </tr>
	  </table>
    <table class="biaogea" v-show="show8">
      <h1>VIP区账号身份信息实名认证服务协议</h1>
      <tr>
      	<td>
      	<strong>1、特别提示</strong>
      	<p>
      	    &nbsp;&nbsp;&nbsp;&nbsp;1.1 用户在使用塔人网络提供的自助服务账号身份信息实名认证之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。
      	</p>
      	<p>
      	    &nbsp;&nbsp;&nbsp;&nbsp;1.2 如用户进入自助服务-VIP区账号身份信息实名认证页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。
      	</p>
      	<strong>2、服务内容</strong>
      	<p>
      	  &nbsp;&nbsp;&nbsp;&nbsp;用户可通过此页面自助申请VIP区账号身份信息实名认证服务，塔人网络收到申请后会根据用户提供的资料完整情况进行相应操作。
      	</p>
      	<strong>3、使用规则</strong>
      	 <p  style="color:red">
      	  &nbsp;&nbsp;&nbsp;&nbsp;3.1 用户承诺以其真实身份申请自助VIP区账号身份信息实名认证服务。并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。
      	<p  style="color:red">
      	  &nbsp;&nbsp;&nbsp;&nbsp;3.2 塔人网络有权审查用户所提供的身份信息是否真实、有效。如果用户提供的资料不准确，不真实，不合法有效，塔人网络保留结束用户使用塔人网络各项服务的权利。
      	</p>
      	<p  style="color:red">
      	  &nbsp;&nbsp;&nbsp;&nbsp;3.3 严禁使用伪造、变造的居民身份证，伪造、变造居民身份证的行为已经构成犯罪，官方一旦发现用户使用虚假身份证件，将收集图片、视频信息提交给公安机关，依法追究法律责任。
      	</p>
      	<p style="color:red">
      	  &nbsp;&nbsp;&nbsp;&nbsp;3.4 如因用户违反有关法律、法规或本协议项下的任何条款而给塔人网络或任何其他第三方造成损害的，用户应当承担由此造成的损害赔偿责任。
        </p>
      	<strong>4、争议解决</strong>
      	<p>
      	  &nbsp;&nbsp;&nbsp;&nbsp;4.1 本协议的订立、履行、解释及争议的解决均应适用中国法律。
      	</p>
      	<p>
      	  &nbsp;&nbsp;&nbsp;&nbsp;4.2 本协议的订立、履行、解释及争议的解决均应以塔人网络所提供之任何形式之电子数据、书面数据等相关内容为准，用户在此确认该等数据的准确性、有效性、合法性。
      	</p>
      	<p>
      	  &nbsp;&nbsp;&nbsp;&nbsp;4.3 如各方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可提交上海仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁的受理费用及处理费用将由提起仲裁一方独立全部承担。
      	</p>
      	<div class="anniu">
      	    <button class="yes" @click="y4">
      	        同意
      	    </button>
      	    <button class="no" @click="no">
      	        不同意
      	    </button>
      	</div>
      </td>
      </tr>
    </table>
	<table class="biaogea" v-show="show9">
		<h1>RO未通过实名认证账号身份信息更改服务协议</h1>
		<tr>
			<td>
			<strong>1、特别提示</strong>
			<p>
			    &nbsp;&nbsp;&nbsp;&nbsp;1.1 用户在使用塔人网络提供的自助服务账号身份信息实名认证之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。
			</p>
			<p>
			    &nbsp;&nbsp;&nbsp;&nbsp;1.2 如用户进入自助服务-未通过实名认证账号身份信息更改页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。
			</p>
			<strong>2、服务内容</strong>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp;用户可通过此页面自助申请未通过实名认证账号身份信息更改服务，塔人网络收到申请后会根据用户提供的资料完整情况进行相应操作。
			</p>
			<strong>3、使用规则</strong>
			 <p  style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp;3.1 用户承诺以其真实身份申请自助未通过实名认证账号身份信息更改服务。并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。
			  </p>
			<p  style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp;3.2 塔人网络有权审查用户所提供的身份信息是否真实、有效。如果用户提供的资料不准确，不真实，不合法有效，塔人网络保留结束用户使用塔人网络各项服务的权利。
			</p>
			<p  style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp; 3.3 严禁使用伪造、变造的居民身份证，伪造、变造居民身份证的行为已经构成犯罪，官方一旦发现用户使用虚假身份证件，将收集图片、视频信息提交给公安机关，依法追究法律责任。
			</p>
			<p style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp; 3.4 如因用户违反有关法律、法规或本协议项下的任何条款而给塔人网络或任何其他第三方造成损害的，用户应当承担由此造成的损害赔偿责任。
			</p>
			<strong>4、争议解决</strong>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp;4.1 本协议的订立、履行、解释及争议的解决均应适用中国法律。
			</p>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp;4.2 本协议的订立、履行、解释及争议的解决均应以塔人网络所提供之任何形式之电子数据、书面数据等相关内容为准，用户在此确认该等数据的准确性、有效性、合法性。
			</p>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp;4.3 如各方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可提交上海仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁的受理费用及处理费用将由提起仲裁一方独立全部承担。
			</p>
			<div class="anniu">
			    <button class="yes" @click="y5">
			        同意
			    </button>
			    <button class="no" @click="no">
			        不同意
			    </button>
			</div>
		</td>
		</tr>
	</table>
	<table class="biaogea" v-show="show10">
		<h1>账号身份证信息重置服务协议</h1>
		<tr>
			<td>
			<strong>1、特别提示</strong>
			<p>
			    &nbsp;&nbsp;&nbsp;&nbsp;1.1 用户在使用塔人网络提供的自助服务账号身份信息实名认证之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。
			</p>
			<p>
			    &nbsp;&nbsp;&nbsp;&nbsp;1.2 如用户进入自助服务-账号身份证信息重置页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。
			</p>
			<strong>2、服务内容</strong>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp; 用户可通过此页面自助申请账号身份证信息重置服务，塔人网络收到申请后会根据用户提供的资料完整情况进行相应操作。
			</p>
			<strong>3、使用规则</strong>
			 <p  style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp;3.1 用户承诺以其真实身份申请自助未通过实名认证账号身份信息更改服务。并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。
			  </p>
			<p  style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp;3.2 塔人网络有权审查用户所提供的身份信息是否真实、有效。如果用户提供的资料不准确，不真实，不合法有效，塔人网络保留结束用户使用塔人网络各项服务的权利。
			</p>
			<p  style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp; 3.3 严禁使用伪造、变造的居民身份证，伪造、变造居民身份证的行为已经构成犯罪，官方一旦发现用户使用虚假身份证件，将收集图片、视频信息提交给公安机关，依法追究法律责任。
			</p>
			<p style="color:red">
			  &nbsp;&nbsp;&nbsp;&nbsp; 3.4 如因用户违反有关法律、法规或本协议项下的任何条款而给塔人网络或任何其他第三方造成损害的，用户应当承担由此造成的损害赔偿责任。
			</p>
			<strong>4、争议解决</strong>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp;4.1 本协议的订立、履行、解释及争议的解决均应适用中国法律。
			</p>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp;4.2 本协议的订立、履行、解释及争议的解决均应以塔人网络所提供之任何形式之电子数据、书面数据等相关内容为准，用户在此确认该等数据的准确性、有效性、合法性。
			</p>
			<p>
			  &nbsp;&nbsp;&nbsp;&nbsp;4.3 如各方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可提交上海仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁的受理费用及处理费用将由提起仲裁一方独立全部承担。
			</p>
			<div class="anniu">
			    <button class="yes" @click="y6">
			        同意
			    </button>
			    <button class="no" @click="no">
			        不同意
			    </button>
			</div>
		</td>
		</tr>
	</table>
	<table class="biaogea" v-show="show11">
			  <h1>子账号换绑主账号服务协议</h1>
			  <tr>
			  	<td>
					<strong>1、特别提示</strong>
					<p>
					    &nbsp;&nbsp;&nbsp;&nbsp;1.1 用户在使用塔人网络提供的自助服务子账号换绑主账号之前，应仔细阅读本服务协议，如用户不同意本服务协议，请停止使用此服务。
					</p>
					<p>
					    &nbsp;&nbsp;&nbsp;&nbsp;1.2 如用户进入自助服务-账号信息身份修改页面并点选“我同意塔人网络用户页面自助服务协议”，即表示用户与塔人网络已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。
					</p>
					<strong>2、服务内容</strong>
					<p>
					  &nbsp;&nbsp;&nbsp;&nbsp;用户可通过此页面自助申请账号信息身份修改服务，塔人网络收到申请后会根据用户提供的资料完整情况进行相应操作。
					</p>
					<strong>3、使用规则</strong>
					 <p  style="color:red">
					  &nbsp;&nbsp;&nbsp;&nbsp;3.1 用户承诺以其真实身份自助申请子账号换绑主账号服务。并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和本协议约定对所提供的信息承担相应的法律责任。
					<p  style="color:red">
					  &nbsp;&nbsp;&nbsp;&nbsp;3.2 塔人网络有权审查用户所提供的身份信息是否真实、有效。如果用户提供的资料不准确，不真实，不合法有效，塔人网络保留结束用户使用塔人网络各项服务的权利。
					</p>
					<p  style="color:red">
					  &nbsp;&nbsp;&nbsp;&nbsp;3.3 严禁使用伪造、变造的居民身份证，伪造、变造居民身份证的行为已经构成犯罪，官方一旦发现用户使用虚假身份证件，将收集图片、视频信息提交给公安机关，依法追究法律责任。
					</p>
					<p style="color:red">
					  &nbsp;&nbsp;&nbsp;&nbsp;3.4 如因用户违反有关法律、法规或本协议项下的任何条款而给塔人网络或任何其他第三方造成损害的，用户应当承担由此造成的损害赔偿责任。
					</p>
					<strong>4、争议解决</strong>
					<p>
					  &nbsp;&nbsp;&nbsp;&nbsp;4.1 本协议的订立、履行、解释及争议的解决均应适用中国法律。
					</p>
					<p>
					  &nbsp;&nbsp;&nbsp;&nbsp;4.2 本协议的订立、履行、解释及争议的解决均应以塔人网络所提供之任何形式之电子数据、书面数据等相关内容为准，用户在此确认该等数据的准确性、有效性、合法性。
					</p>
					<p>
					  &nbsp;&nbsp;&nbsp;&nbsp;4.3 如各方就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可提交上海仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁的受理费用及处理费用将由提起仲裁一方独立全部承担。
					</p>
					<div class="anniu">
					    <button class="yes" @click="y7">
					        同意
					    </button>
					    <button class="no" @click="no">
					        不同意
					    </button>
					</div>
				</td>
			  </tr>
	</table>
      <item :list_data="tabList" :gameData="gameData" :tid='sid' :gameid='id':cast='typeid' v-show="show4" ref="formlist">

      </item>
      <div v-show="show7">
        <div class="w-g-information ">
            <h2></h2>
            <div id="applyBox">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="230px" class="demo-ruleForm">
                  <el-form-item label="请选择服务器(区):" prop="server" style="display: inline-block" >
                      <el-select v-model="ruleForm['server']" style="width:320px"  v-if='sid != 5'>
                          <el-option v-for='item in gameData' :label="item.info" :value="item.info" :key="item.id"></el-option>
                      </el-select>
                      <el-select v-model="ruleForm['server']" style="width:320px"  v-if='sid == 5'>
                          <el-option label="VIP1区" value="38"></el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item label="角色名" prop="role" class="fixwidth"  >
                         <el-input  type="text" v-model="ruleForm['role']"  placeholder="请输入角色名" class="width"  ></el-input>
                  </el-form-item>
                  <el-form-item label="姓名" prop="name" class="fixwidth"  >
                         <el-input  type="text" v-model="ruleForm['name']"  placeholder="请输入姓名" class="width"  ></el-input>
                         <div class="rediotip">请填写可以签收线下礼包的姓名。</div>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="idcard" class="fixwidth"  >
                         <el-input  type="text" v-model="ruleForm['idcard']"  placeholder="请输入完整身份证号" class="width"  ></el-input>
                    </el-form-item>
                    <el-form-item label="生日" prop="birthday" class="fixwidth">
                         <el-date-picker
                                 v-model="ruleForm['birthday']"
                                 type="date"
                                 placeholder="请输入出生日期"
                                 format="MM-dd"
                                 value-format="MM-dd"
                         >
                         </el-date-picker>
                         <div class="rediotip">生日日期仅做线下生日礼包的回馈，如在生日当月未能完成贵宾认证，逾期认证的不予补发线下生日礼包。</div>
                    </el-form-item>
                    <el-form-item label="贵宾等级" class="fixwidth"  >
                         <div class="width"><span style="font-weight:bold; color: #E81122;">{{vipl}}</span></div>
                    </el-form-item>
                    <el-form-item label="认证QQ号码" prop="qqnum" class="fixwidth"  >
                         <el-input  type="text" v-model="ruleForm['qqnum']" placeholder="请输入认证QQ号码" class="width"  ></el-input>
                         <div class="rediotip">请正确输入信息，贵宾专属秘书将对其添加贵宾标签。</div>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="phonenum" class="fixwidth"  >
                         <el-input  type="text" v-model="ruleForm['phonenum']" placeholder="请输入手机号码" class="width"  ></el-input>
                    </el-form-item>
                    <el-form-item label="是否能接受线下礼品" class="fixwidth" prop="back">
                         <el-radio-group  v-model="ruleForm['back']">
                           <el-radio label="是">是</el-radio>
                           <el-radio label="否">否</el-radio>
                         </el-radio-group>
                    </el-form-item>
                    <!-- <el-form-item label="接受回访的时间" class="fixwidth" v-show="ruleForm['back']=='是'">
                           <el-date-picker
                                   v-model="ruleForm['backstime']"
                                   type="datetime"
                                   placeholder="开始时间"
                                   format="yyyy-MM-dd HH:mm:ss"
                                   value-format="yyyy-MM-dd HH:mm:ss"
                           >
                           </el-date-picker>
                           <el-date-picker
                                   v-model="ruleForm['backetime']"
                                   type="datetime"
                                    placeholder="结束时间"
                                   format="yyyy-MM-dd HH:mm:ss"
                                   value-format="yyyy-MM-dd HH:mm:ss"
                           >
                           </el-date-picker>
                    </el-form-item> -->
                    <el-form-item label="所在地区" class="fixwidth" prop="area" v-show="ruleForm['back']=='是'">
                        <el-select v-model="prov" style="width: 140px;" >
                        <el-option v-for="(option, index) in arr" :disabled="edit" :value="option.name" :key="index">{{ option.name }}</el-option>
                        </el-select>
                        <el-select v-model="city" style="width: 140px;">
                        <el-option v-for="(option, index) in cityArr" :disabled="edit" :value="option.name" :key="index">{{ option.name }}</el-option>
                        </el-select>
                        <el-select v-model="district" v-if="district" style="width: 140px;">
                        <el-option v-for="(option, index) in districtArr" :disabled="edit" :value="option.name" :key="index">{{ option.name }}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="addr" class="fixwidth" v-show="ruleForm['back']=='是'">
                         <el-input  type="text" v-model="ruleForm['addr']"  placeholder="请填写您的详细地址" class="width"></el-input>
                         <div class="rediotip">无需线下礼包的用户不用填写详细地址。</div>
                    </el-form-item>
                    <el-form-item label="联系邮箱" prop="email" class="fixwidth"  >
                         <el-input  type="text" v-model="ruleForm['email']"  placeholder="请填写您的联系邮箱" class="width"></el-input>
                    </el-form-item>
              </el-form>
              <div class="biaogea">
                <div class="submitBtnPanel  anniua" style="margin-top:20px;padding-bottom:60px;cursor:pointer">
                    <a @click='submitForm()'>
                        确定
                    </a>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div v-show="show6">
          <div class="w-g-information ">
              <h2></h2>
              <div id="applyBox">
                <el-form label-width="230px" class="demo-ruleForm">
                  <el-form-item label="服务器(区):"class="fixwidth">
                         <el-input type="text" v-model="tserver" class="width" readonly="readonly"></el-input>
                  </el-form-item>
                  <el-form-item label="角色名"class="fixwidth">
                         <el-input type="text" v-model="tname" class="width" readonly="readonly"></el-input>
                  </el-form-item>
                  <el-form-item label="生日"class="fixwidth">
                         <el-input type="text" v-model="bday" class="width" readonly="readonly"></el-input>
                  </el-form-item>
                  <el-form-item label="贵宾等级"class="fixwidth">
                         <div class="width"><span style="font-weight:bold;">{{thevip}}</span></div>
                  </el-form-item>
                    <el-form-item label="认证QQ号码"class="fixwidth">
                           <el-input type="text" v-model="qq" class="width" readonly="readonly"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" class="fixwidth">
                           <el-input type="text" v-model="phone" class="width" readonly="readonly"></el-input>
                    </el-form-item>
                    <el-form-item label="是否能接受线下礼品" class="fixwidth">
                           <el-radio-group  v-model="huifang" disabled>
                             <el-radio label="是">是</el-radio>
                             <el-radio label="否">否</el-radio>
                           </el-radio-group>
                    </el-form-item>
                    <!-- <el-form-item label="接受回访的时间" class="fixwidth" v-if="huifang=='是'">
                           <el-date-picker
                                   v-model="time1"
                                   type="datetime"
                                   format="yyyy-MM-dd HH:mm:ss"
                                   value-format="yyyy-MM-dd HH:mm:ss"
                                   readonly="readonly"
                           >
                           </el-date-picker>
                           <el-date-picker
                                   v-model="time2"
                                   type="datetime"
                                   format="yyyy-MM-dd HH:mm:ss"
                                   value-format="yyyy-MM-dd HH:mm:ss"
                                   readonly="readonly"
                           >
                           </el-date-picker>
                    </el-form-item> -->
                    <el-form-item label="详细地址" class="fixwidth" v-if="huifang=='是'">
                           <el-input type="text" v-model="location" class="width" readonly="readonly"></el-input>
                    </el-form-item>
                    <el-form-item label="联系邮箱" class="fixwidth">
                           <el-input type="text" v-model="email" class="width" readonly="readonly"></el-input>
                    </el-form-item>
                </el-form>
                <div class="biaogea">
                  <div class="submitBtnPanel  anniua" style="margin-top:20px;padding-bottom:60px;cursor:pointer">
                      <a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>
                        如需修改信息，点击联系客服
                      </a>
                  </div>
                </div>
              </div>
          </div>
      </div>
	  </div>
		<div style="margin:30px 0px 0px 40px;">温馨提示：</div>
    <div style="margin:0px 40px 30px 40px;" v-show="show5">
      <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; line-height: 20px; color: rgb(34, 30, 31); font-family: 微软雅黑, &#39;Microsoft Yahei&#39;, MSYH; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);">
      <span style="margin: 0px; padding: 0px; font-family: 宋体;">1.正确填写认证QQ号码便于客服添加贵宾专属认证标签，享受贵宾专属服务通道。</span>
      </p>
      <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; line-height: 20px; color: rgb(34, 30, 31); font-family: 微软雅黑, &#39;Microsoft Yahei&#39;, MSYH; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);">
      <span style="margin: 0px; padding: 0px; font-family: 宋体;">2.凡认证成功并留有正确通讯地址及联系方式的贵宾帐号，会在生日当月收到线下生日礼品一份。（如身份证下有多个帐号为贵宾帐号只会获得-份线下生日礼品）</span>
      </p>
      <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; line-height: 20px; color: rgb(34, 30, 31); font-family: 微软雅黑, &#39;Microsoft Yahei&#39;, MSYH; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);">
      <span style="margin: 0px; padding: 0px; font-family: 宋体;">3.首次认证礼包只针对第一次成为贵宾用户的帐号进行发放。在原代理商2016年4月1日升级贵宾体系后新成为的贵宾用户即可享首次认证礼包，至2016年3月31日保有贵宾资格的用户不在此范围内，每个帐号只可获得一次首次认证礼包。</span>
      </p>
      <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; line-height: 20px; color: rgb(34, 30, 31); font-family: 微软雅黑, &#39;Microsoft Yahei&#39;, MSYH; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);">
      <span style="margin: 0px; padding: 0px; font-family: 宋体;">4.未进行贵宾用户身份认证的玩家将无法获得除首次认证礼包及节日礼包以外的其他礼包/礼品奖励。</span>
      </p>
      <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; line-height: 20px; color: rgb(34, 30, 31); font-family: 微软雅黑, &#39;Microsoft Yahei&#39;, MSYH; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);">
      <span style="margin: 0px; padding: 0px; font-family: 宋体;">5.已认证过但是没有修改帐号身份证，需要修改贵宾绑定QQ的，请玩家使用帐号的绑定邮箱（用于重置帐号登录密码的邮箱地址）发送变更申请至guibin@zhaouc.com，邮件内容中说明以下内容:帐号、区服、角色名、完整的身份证号码、原绑定QQ号码、新的绑定Q0号码及联系电话，核对后会帮助完成变更操作。</span>
      </p>
      <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; line-height: 20px; color: rgb(34, 30, 31); font-family: 微软雅黑, &#39;Microsoft Yahei&#39;, MSYH; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);">
      <span style="margin: 0px; padding: 0px; font-family: 宋体;">6.已认证过但是已对账号重新修改身份证信息的贵宾用户，请重新进行认证。</span>
      </p>
      <p style="margin-top: 0px; margin-bottom: 0px; padding: 0px; line-height: 20px; color: rgb(34, 30, 31); font-family: 微软雅黑, &#39;Microsoft Yahei&#39;, MSYH; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);">
      <span style="margin: 0px; padding: 0px; font-family: 宋体;">7.贵宾用户身份信息填写成功后自动显示，表单不进行确认回复。 区服及角色名审核不通过的用户，我们会在3个工作日内通过贵宾邮箱进行回访。</span>
      </p>
      <p><br/></p>
	</div>
	  	<div v-html="other"style="margin:0px 40px 30px 40px;"v-show="!show5">{{other}}</div>
	    <div class="hujiao">
	      <p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
	      <p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
	    </div>
	  </div>
    </div>
  </div>
  </div>
</template>

<script>
  let getIdCardInfo = function getIdCardInfo(cardNo) {
      try {
      var info = {
          isTrue: false, // 身份证号是否有效。默认为 false
          year: null, // 出生年。默认为null
          month: null, // 出生月。默认为null
          day: null, // 出生日。默认为null
          isMale: false, // 是否为男性。默认false
          isFemale: false // 是否为女性。默认false
      };
      if (!cardNo && 15 != cardNo.length && 18 != cardNo.length) {
          info.isTrue = false;
          return info;
      }
      if (15 == cardNo.length) {
          var year = cardNo.substring(6, 8);
          var month = cardNo.substring(8, 10);
          var day = cardNo.substring(10, 12);
          var p = cardNo.substring(14, 15); // 性别位
          var birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
          // 对于老身份证中的年龄则不需考虑千年虫问题而使用getYear()方法
          // @ts-ignore
          if (birthday.getYear() != parseFloat(year) || birthday.getMonth() != parseFloat(month) - 1 || birthday.getDate() != parseFloat(day)) {
              info.isTrue = false;
          } else {
              // @ts-ignore
              info.isTrue = true;
              // @ts-ignore
              info.year = birthday.getFullYear();
              // @ts-ignore
              info.month = birthday.getMonth() + 1;
              // @ts-ignore
              info.day = birthday.getDate();
              if (p % 2 == 0) {
                  info.isFemale = true;
                  info.isMale = false;
              } else {
                  info.isFemale = false;
                  info.isMale = true;
              }
          }
          return info;
      }
      if (18 == cardNo.length) {
          var year = cardNo.substring(6, 10);
          var month = cardNo.substring(10, 12);
          var day = cardNo.substring(12, 14);
          var p = cardNo.substring(14, 17);
          var birthday = new Date(year, parseFloat(month) - 1, parseFloat(day));
          // 这里用getFullYear()获取年份，避免千年虫问题
          if (birthday.getFullYear() != parseFloat(year) || birthday.getMonth() != parseFloat(month) - 1 || birthday.getDate() != parseFloat(day)) {
              info.isTrue = false;
              return info;
          }
          var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
          var Y = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X
          // 验证校验位
          var sum = 0; // 声明加权求和变量
          var _cardNo = cardNo.split("");
          if (_cardNo[17].toLowerCase() == 'x') {
              _cardNo[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
          }
          for (var i = 0; i < 17; i++) {
              sum += Wi[i] * _cardNo[i]; // 加权求和
          }
          var i = sum % 11; // 得到验证码所位置
          if (_cardNo[17] != Y[i]) {
              return info.isTrue = false;
          }
          info.isTrue = true;
          // @ts-ignore
          info.year = birthday.getFullYear();
          // @ts-ignore
          info.month = birthday.getMonth() + 1;
          // @ts-ignore
          info.day = birthday.getDate();
          if (p % 2 == 0) {
              info.isFemale = true;
              info.isMale = false;
          } else {
              info.isFemale = false;
              info.isMale = true;
          }
          return info;
      }
      return info;
      }catch (e) {
          return {isTrue:false}
      }
  };
  import item from "@/components/form_item.vue";
  import Top from '@/components/top.vue'
  import area from "../../static/assets/area.js"
  export default {
    name: "game",
    components: {
      item,
      Top
    },
    data () {
      return {
        wtlist:[],
        id:this.$route.query.gameid,
        game:this.$route.query.gname,
        wtname:this.$route.query.typename,
        typeid:this.$route.query.typeid,
        vip:this.$route.query.vip||'',
        attestation:this.$route.query.attestation||'',
        gameData:[],
        tabList:[],
        choose:'',
        tablename:'',
        other:'',
        bgId:'',
        sid:'',
        vipl:'',
		show:true,
		show1:false,
		show2:false,
		show3:false,
    show4:true,
    show5:false,
    show6:false,
    show7:false,
    show8:false,
	show9:false,
	show10:false,
	show11:false,
    tserver:'',
    tname:'',
    thevip:'',
    qq:'',
    phone:'',
    huifang:'',
    bday:'',
    //time1:'',
    //time2:'',
    location:'',
    email:'',
    arr: area.arrAll,
    prov: '省份',
    city: '城市',
    district: '区域',
    cityArr: [],
    districtArr: [],
    edit: false,
    iscity: false,
    isdistrict: false,
    ruleForm:{
      back:'是'
      }
    }
    },
    beforeMount() {
    	this.updateCity();
    	this.updateDistrict();
    },
    watch: {
    	prov: function() {
    		this.updateCity();
    		this.updateDistrict();
    	},
    	city: function() {
    		this.updateDistrict();
    	},
    },
    created() {
      this.gameBg()
      this.gameWt()
      this.getgameQ()
      if(this.attestation){
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/sort',
          params: {
            gameid:this.id,
          }
        }).then(res => {
          if(res.data.status==200){
            this.vip=res.data.vip
          }
        })
        this.gameWt3()
      }
    },
    computed:{
        rules(){
          let self=this;
          let obj={
            'role':[ { required: true, message: '请输入角色名', trigger: 'blur' }],
            'server':[ {required: true, message: '请选择区服', trigger: 'change' }],
            'name':[{required: true, message: '请输入姓名', trigger: 'blur' }],
            'idcard':[{validator: self.cardcheck, message: '请输入正确格式的身份证号', trigger: 'blur' },{required: true, message: '请输入身份证号', trigger: 'blur' }],
            'qqnum':[{required: true, message: '请输入认证QQ号码', trigger: 'blur' }],
            'phonenum':[{ validator: self.validPhone, message: '请输入手机号码', trigger: 'blur' },{required: true, message: '请输入手机号码', trigger: 'blur' }],
            'addr':[{required: false, message: '请填写您的详细地址', trigger: 'blur' }],
            'email':[{type: 'email', message: '请填写您的联系邮箱', trigger: 'blur' },{required: true, message: '请填写您的联系邮箱', trigger: 'blur' }],
          }
          return obj;
        }
    },
    methods: {
      init(){
        this.$refs['ruleForm'].clearValidate()
      },
      uploadcheck(rule, value, callback){
        if(value=='视频验证'){
          callback();
          return;
        }
        if(!value){
          callback(new Error(rule.message));
          return
        }
        try {
          value=JSON.parse(value)
        }catch (e) {
          callback(new Error(rule.message));
        }
        if(value&&value.length>0){
          callback();
          return;
        }else{
          callback(new Error(rule.message));
          return;
        }
      },
      cardcheck(rule, value, callback){
        // @ts-ignore
        if(getIdCardInfo(value).isTrue){
          callback();
          return;
        }else{
          callback(new Error(rule.message));
          return;
        }
      },
      submitForm(){
        //let ff=true
        let fff=true
        this.$refs['ruleForm'].validate((valid)=>{
          if(valid){
            if(this.ruleForm['back']=='否'){
              //this.ruleForm['backstime']=''
              //this.ruleForm['backetime']=''
              this.ruleForm['area']=''
              this.ruleForm['addr']=''
            }else{
              // if(this.ruleForm['backstime']){
              //   if(this.ruleForm['backetime']){
              //     ff=true
              //   }else{
              //     ff=false
              //     this.$alert('请填写您的回访时间', {
              //     	confirmButtonText: '确定',
              //     });
              //   }
              // }else{
              //   ff=false
              //   this.$alert('请填写您的回访时间', {
              //   	confirmButtonText: '确定',
              //   });
              // }
              if(this.prov=='省份'){
                fff=false
                this.$alert('请填写您所在地区', {
                	confirmButtonText: '确定',
                });
              }else{
                fff=true
                if(this.district){
                  this.ruleForm['area']=this.prov+'-'+this.city+'-'+this.district
                }else{
                  this.ruleForm['area']=this.prov+'-'+this.city
                }
              }
            }
            this.ruleForm['game']=this.id
            //this.ruleForm['area']=this.prov+this.city+this.district
            this.ruleForm['viplever']=this.vipl
            if(fff){
              this.$axios({
                method: 'post',
                url: '/index.php/user/User/vippost',
                data : this.ruleForm
              }).then(res => {
                if(res.data.status==200){
                  this.$alert(res.data.data, {
                  	confirmButtonText: '确定',
                  });
				  this.upd()
                }else{
                  this.$alert(res.data.msg, {
                  	confirmButtonText: '确定',
                  });
                }
              })
            }
          }
        })
      },
      validPhone(rule, value, callback){
        if (!value){
          callback(new Error('请输入电话号码'))
        }else  if (! /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(value)){
          callback(new Error('请输入正确的11位手机号码'))
        }else {
          callback()
        }
      },
      tihuan(m){
        var num=m.length-3
        var m1=m.split('')
        for(var i=2;i<num;i++){
          m1[i]='*'
        }
        return m1.join('')
      },
      upd(){
        this.show6=true
        this.show7=false
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/viplist',
          params: {
            game:this.id,
          }
        }).then(res => {
          if(res.data.status==200){
            this.tserver=res.data.msg[0].server
            this.tname=res.data.msg[0].role
            this.thevip=res.data.msg[0].viplever
            this.bday=res.data.msg[0].birthday
            this.qq=this.tihuan(res.data.msg[0].qqnum)
            this.phone=this.tihuan(res.data.msg[0].phonenum)
            this.huifang=res.data.msg[0].back
            //this.time1=res.data.msg[0].backstime
            //this.time2=res.data.msg[0].backetime
            if(this.huifang=='是'){
              this.location=this.tihuan(res.data.msg[0].addr)
            }
            this.email=this.tihuan(res.data.msg[0].email)
          }
        })
      },
      updateCity: function() {
      			this.iscity = false;
      			for (var i in this.arr) {
      				var obj = this.arr[i];
      				if (obj.name) {
      					if (obj.name == this.prov) {
      						this.cityArr = obj.sub;
      						break;
      					}
      				}
      			}
      			if (this.cityArr && this.cityArr.length > 0 && this.cityArr[1].name) {
      				for (var i in this.cityArr) {
      					var obj = this.cityArr[i];
      					if (obj.name == this.city) {
      						this.city = obj.name;
      						this.iscity = true;
      						break;
      					}
      				}
      				if (!this.iscity) {
      					this.city = this.cityArr[1].name;
      				}
      			} else {
      				this.city = '城市';
      			}
      		},
      		//更新区域数据
      		updateDistrict: function() {
      			var i = 1;
      			this.isdistrict = false;
      			for (var i in this.cityArr) {
      				var obj = this.cityArr[i];
      				if (obj.name == this.city) {
      					this.districtArr = obj.sub;
      					break;
      				}
      			}
      			if(this.cityArr[i].sub!=undefined){
      			if(this.cityArr[i].sub[0].name!=""){
      			if (this.districtArr && this.districtArr.length > 0&&this.districtArr[1].name) {
      				for (var i in this.districtArr) {
      					var obj = this.districtArr[i];
      					if (obj.name == this.district) {
      						this.district = obj.name;
      						this.isdistrict = true;
      						break;
      					}
      				}
      				if (!this.isdistrict) {
      					this.district = this.districtArr[1].name;
      				}
      			}
      			}else{
      				this.district=""
      			}
      			}else{
      				this.district=""
      			}
      		},
		getform(){
			this.$axios({
			  method: 'post',
			  url: '/index.php/user/User/forminfo',
			  params: {
			    id:this.sid,
			  }
			}).then(res => {
			  if(res.data.status==200){
				this.tabList=res.data.data;
				this.$nextTick(()=>{
				this.$refs['formlist'].init();
				this.$forceUpdate();
				})
			  }else{
			    this.tabList=[]
			  }
			})
		},
      gameBg() {
        if (this.id == 1) {
          this.bgId = 'sun'
        } else if (this.id == 2) {
          this.bgId = 'mu'
        } else if (this.id == 3) {
          this.bgId = 'mu2'
        } else if (this.id == 4) {
          this.bgId = 'ro'
        } else if (this.id == 5) {
          this.bgId = 'moli'
        }
      },
      gameWt(){
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/gameform',
          params: {
            gameid:this.id,
            sortid:this.typeid
          }
        }).then(res => {
          if(res.data.status==200){
            this.wtlist=res.data.data
			if(res.data.data.length>0){
				this.wtlist=res.data.data
				let  wt=this.wtlist[0]
				this.an(wt.tablename,wt.id,wt.other)
			}
          }else if(res.data.status==500){
			 document.cookie=''
			 this.$router.push({path:"/clogin"})
		  }else{
            this.wtlist=[]
          }
        })
      },
	  gameWt1(){
	    this.$axios({
	      method: 'get',
	      url: '/index.php/user/User/gameform',
	      params: {
	        gameid:2,
	        sortid:8
	      }
	    }).then(res => {
	      if(res.data.status==200){
	        let  wt=res.data.data[0]
	        this.an(wt.tablename,wt.id,wt.other)
	      }
	    })
	  },
	  gameWt2(){
	    this.$axios({
	      method: 'get',
	      url: '/index.php/user/User/gameform',
	      params: {
	        gameid:1,
	        sortid:20
	      }
	    }).then(res => {
	      if(res.data.status==200){
	        let  wt=res.data.data[0]
	        this.an(wt.tablename,wt.id,wt.other)
	      }
	    })
	  },
    gameWt3(){
      let i
      if(this.id=="1"){
        i=12
      }else{
        i=6
      }
      this.$axios({
        method: 'get',
        url: '/index.php/user/User/yzvip',
        params: {
          gameid:i,
        }
      }).then(res => {
        if(res.data.status==200){
          this.vipl=res.data.level;
          this.$axios({
            method: 'get',
            url: '/index.php/user/User/firstvippost',
            params: {
              game:this.id,
            }
          }).then(res => {
            if(res.data.status==200){
              this.show6=false
              this.show7=true
            }else if(res.data.status==500){
              this.upd()
            }
            this.show=true
            this.tablename='贵宾用户身份认证'
            this.show1=false
            this.show2=false
            this.show3=false
            this.show4=false
            this.show8=false
			this.show9=false
			this.show10=false
			this.show11=false
            this.show5=true
          })
        }else if(res.data.status==500){
          this.$alert('对不起，你当前不是贵宾用户，不能编辑此表单。', {
          	confirmButtonText: '确定',
          });
        }
      })
    },
	  getgameQ(){
		this.$axios({
		  method: 'get',
		  url: '/index.php/user/User/gameinfo',
		  params: {
			id:this.id,
		  }
		}).then(res => {
		  if(res.data.status==200){
			this.gameData=res.data.data
		  }else{
			this.gameData=[]
		  }
		})
	  },
    an(tname,id,other){
		this.show=true
		this.show1=false
		this.show2=false
		this.show3=false
		this.show4=true
		this.show5=false
		this.show6=false
		this.show7=false
		this.show8=false
		this.show9=false
		this.show10=false
		this.show11=false
		this.tablename=tname
		this.other=other
		this.sid=id
    if(id==69){
      this.show=false;
      this.show4=false;
      this.show8=true;
    }else if(id==34||id==4||id==17){
			this.show=false;
			this.show4=false;
			this.show2=true;
		}else if(id==5||id==6||id==7||id==18||id==19||id==32||id==40||id==52||id==53){
			this.show=false;
			this.show4=false;
			this.show3=true;
		}else if(id==13||id==38||id==30){
			this.show=false;
			this.show4=false;
			this.show1=true;
		}else if(id==74){
			this.show=false;
			this.show4=false;
			this.show9=true;
		}else if(id==76){
			this.show=false;
			this.show4=false;
			this.show10=true;
		}else if(id==78||id==79||id==80){
			this.show=false;
			this.show4=false;
			this.show11=true;
		}else{
			this.an1()
		}
      },
	  an1(){
		var id=this.sid
		if(id == 88){
		  this.$alert('本表单仅受理：未通过官方通道办理过实名认证业务的账号，注册人可发起注册信息单次修改申请（仅此一次）。', {
			confirmButtonText: '确定',
		  });
		}
		if(id == 63){
		  this.$alert('此表单不受理VIP区乱码身份证号修改申请。', {
			confirmButtonText: '确定',
		  });
		}
		if(id == 10){
		  this.$alert('普通元素卷轴升阶精通元素卷轴失败、普通元素之魂升阶精通元素之魂失败不在表单受理范围之内。', {
			confirmButtonText: '确定',
		  });
		}
		if (id == 6 || id == 7) {
			this.$alert('此表单不受理VIP区账号身份信息及绑定邮箱修改！', {
				confirmButtonText: '确定',
			});
		}
		if (id == 30) {
			this.$alert('2020年1月1日开始，账号如果没有绑定微信令宝并开启封停功能，发生被盗后官方将不再提供查询找回服务。', {
				confirmButtonText: '确定',
			});
		}
		if (id == 13) {
			this.$alert('2022年4月1日开始，账号如果没有绑定微信令宝并开启封停功能，发生被盗后官方将不再提供查询找回服务。', {
				confirmButtonText: '确定',
			});
		}
		if (id == 50 || id == 47|| id == 48) {
			this.$alert('该表单仅受理有封停处罚期限账号的解封申请。为提升高效便捷的服务，一个表单只能提交一个账号的解封申请。', {
				confirmButtonText: '确定',
			});
		}
		this.getform()
	  },
	  no(){
		this.$router.go(-1);
	  },
	  y1(){
		this.show=true;
		this.show4=true;
		this.show1=false;
		this.an1()
	  },
	  y2(){
		this.show=true;
		this.show4=true;
		this.show2=false;
		this.an1()
	  },
	  y3(){
		this.show=true;
		this.show4=true;
		this.show3=false;
		this.an1()
	  },
    y4(){
      this.show=true;
      this.show4=true;
      this.show8=false;
      this.an1()
    },
	y5(){
	  this.show=true;
	  this.show4=true;
	  this.show9=false;
	  this.an1()
	},
	y6(){
	  this.show=true;
	  this.show4=true;
	  this.show10=false;
	  this.an1()
	},
	y7(){
	  this.show=true;
	  this.show4=true;
	  this.show11=false;
	  this.an1()
	}
    }
  }
</script>

<style scoped>
.anniu {
    margin-left: 140px;
	margin-top: 40px;
}
.anniu button {
    width: 130px;
    padding: 10px 20px;
    float: left;
    margin: 0 10px;
}
.fixwidth{display: inline-block;margin:25px 0}
.width{width:320px}
.rediotip{line-height:1.5;font-size:12px;margin:5px 20px 5px 0px;color:#c25205;width:350px}
.up{background: #ffaa00!important;}
</style>



// WEBPACK FOOTER //
// src/views/game.vue